/**
 * Madesa Minicart Controller
 * Handles opening and closing of the minicart drawer
 */

class MinicartController {
  constructor() {
    this.drawer = document.querySelector('.minicart-drawer');
    this.overlay = document.querySelector('[data-minicart-overlay]');
    this.closeBtn = document.querySelector('.minicart-close-btn');
    this.continueShoppingBtn = null;
    
    if (!this.drawer || !this.overlay) {
      console.warn('Minicart elements not found');
      return;
    }

    this.init();
  }

  init() {
    // Inicialmente fechado
    this.close();

    // Event listeners para botões de fechar
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }

    // Fechar ao clicar no overlay
    this.overlay.addEventListener('click', () => this.close());

    // Event listeners para botões de abrir
    this.setupTriggers();

    // Botão "Continuar comprando"
    this.setupContinueShoppingBtn();

    // Event listener para tecla ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) {
        this.close();
      }
    });

    // Event listener customizado para abrir o minicart
    document.addEventListener('minicart:open', () => this.open());
    document.addEventListener('minicart:close', () => this.close());
    document.addEventListener('minicart:toggle', () => this.toggle());
  }

  setupTriggers() {
    // Seleciona todos os botões que podem abrir o minicart
    const triggers = document.querySelectorAll('[data-minicart-trigger], [data-minicart-open]');
    
    triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });


    // Adiciona listener para botões que fecham o minicart
    const closeTriggers = document.querySelectorAll('[data-minicart-close]');
    
    closeTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
      });
    });
  }

  setupContinueShoppingBtn() {
    // Observa mudanças no DOM para capturar o botão quando ele for renderizado
    const observer = new MutationObserver(() => {
      const btn = document.querySelector('.minicart-btn--secondary[data-action="close"]');
      if (btn && btn !== this.continueShoppingBtn) {
        this.continueShoppingBtn = btn;
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.close();
        });
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  open() {
    this.drawer.classList.add('is-open');
    this.overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    
    // Dispara evento customizado
    document.dispatchEvent(new CustomEvent('minicart:opened'));
  }

  close() {
    this.drawer.classList.remove('is-open');
    this.overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    
    // Dispara evento customizado
    document.dispatchEvent(new CustomEvent('minicart:closed'));
  }

  toggle() {
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }

  isOpen() {
    return this.drawer.classList.contains('is-open');
  }
}

// Inicializa quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.minicartController = new MinicartController();
  });
} else {
  window.minicartController = new MinicartController();
}

// API Global para facilitar o uso
window.Minicart = {
  open() {
    document.dispatchEvent(new CustomEvent('minicart:open'));
  },
  close() {
    document.dispatchEvent(new CustomEvent('minicart:close'));
  },
  toggle() {
    document.dispatchEvent(new CustomEvent('minicart:toggle'));
  }
};
